const state = {
  error: null,
  blur: false,
};

// Unused
// TODO Remove?
// August 20, 2021 Brandon: I see it referenced in App.vue but looks unused.
const actions = {
  ClearError({ commit }) {
    commit('CLEAR_ERROR');
  },

  SetError({ commit }, err) {
    commit('SET_ERROR', err);
  },
};

const mutations = {
  SET_ERROR(stateArg, error) {
    const stateCopy = stateArg;
    stateCopy.error = error;
  },

  CLEAR_ERROR(stateArg) {
    const stateCopy = stateArg;
    stateCopy.error = null;
  },

  SET_BLUR(stateArg, blur) {
    const stateCopy = stateArg;
    stateCopy.blur = blur;
  },
};

export default { actions, mutations, state };
